import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useAtomValue } from 'jotai';
import { useFormContext } from 'react-hook-form';
import { Typography, Grid } from '@mui/material';
import FormDatePicker from '../../../../../Components/Form/FormDatePicker';
import FormSelect from '../../../../../Components/Form/FormSelect';
import {
  SOURCES,
  PURPOSES,
  PRODUCT_CODES,
  PRODUCT_SOURCE,
} from '../../../Utils/constants';
import { activityOutcomesAtom, userDataAtom } from '../../../../../Atoms';
import FormTextField from '../../../../../Components/Form/FormTextField';

const useStyles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
});

const PracticePage = function PracticePage({
  errors = null,
  edit = false,
  formData = {},
}) {
  const intl = useIntl();
  const classes = useStyles();
  const { watch, setValue } = useFormContext();
  const { name, surname } = useAtomValue(userDataAtom);

  const activityOutcomes = useAtomValue(activityOutcomesAtom);

  useEffect(() => {
    setValue(
      'practiceState',
      activityOutcomes.DOSSIER.find(({ id }) => id === watch('outcome'))?.name
    );
  }, [watch('outcome')]);

  return (
    <div style={classes.root}>
      <Grid container rowSpacing="18px" columnSpacing="16px">
        <Grid size={{ xs: 12 }}>
          <Typography variant="h6">
            {intl.messages.INSERT_PRACTICE_DATA}
          </Typography>
        </Grid>
        <Grid size={{ md: 4.5, sm: 6, xs: 12 }}>
          <FormTextField
            name="practiceNumber"
            required
            disabled={edit}
            error={errors?.practiceNumber}
            validateCallback={(pNum) =>
              !isNaN(pNum) || intl.messages.NOLETTERS_VALIDATION
            }
          />
        </Grid>
        <Grid size={{ md: 4.5, sm: 6, xs: 12 }}>
          <FormTextField
            name="praticalManagement"
            allUpperCase
            required
            defaultValue={edit ? null : `${name} ${surname}`}
            error={errors?.praticalManagement}
          />
        </Grid>
        <Grid size={{ md: 3, sm: 3, xs: 12 }}>
          <FormDatePicker
            name="dateLoadingPractice"
            required
            error={errors?.dateLoadingPractice}
          />
        </Grid>
        <Grid size={{ md: 4, sm: 4.5, xs: 12 }}>
          <FormSelect
            name="leadSource"
            error={errors?.leadSource}
            options={SOURCES}
            required
          />
        </Grid>
        <Grid size={{ md: 4, sm: 4.5, xs: 12 }}>
          <FormSelect
            name="loanPurpose"
            error={errors?.loanPurpose}
            options={PURPOSES}
            required
          />
        </Grid>
        <Grid size={{ md: 4, sm: 4.5, xs: 12 }}>
          <FormSelect
            name="productSource"
            required
            allUpperCase
            noTranslation
            error={errors?.productSource}
            options={PRODUCT_SOURCE}
          />
        </Grid>
        <Grid size={{ md: 4, sm: 6, xs: 8 }}>
          <FormSelect
            name="outcome"
            label={intl.messages.PRACTICESTATE}
            error={errors?.practiceState}
            // The draft status is set only by the draft practice action.
            options={activityOutcomes.DOSSIER.filter(
              ({ extensionData }) => !extensionData?.isDraft
            ).map(({ id, name }) => ({
              label: name,
              value: id,
            }))}
            defaultValue={
              activityOutcomes.DOSSIER?.find(
                ({ name }) =>
                  name?.toUpperCase() === formData?.practiceState?.toUpperCase()
              )?.id
            }
            required
          />
        </Grid>
        <Grid size={{ md: 4, sm: 6, xs: 4 }}>
          <FormDatePicker
            name="liquidationDate"
            error={errors?.liquidationDate}
          />
        </Grid>
        <Grid size={{ md: 4, sm: 6, xs: 8 }}>
          <FormSelect
            name="productCode"
            error={errors?.productCode}
            options={PRODUCT_CODES}
            required
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default PracticePage;
